import {openDialog} from 'platform/components';
import {Grid, Heading, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {MyProfileTemplate} from '../../components/MyProfileTemplate/MyProfileTemplate';
import {CreateUserMailboxDialog} from './components/CreateUserMailboxDialog';
import {ReceivingMailboxesSection} from './components/ReceivingMailboxesSection';
import {SyncedMessagesDatagrid} from './components/SyncedMessagesDatagrid';

export function EmailSynchronization() {
  const handleCreate = () =>
    openDialog(<CreateUserMailboxDialog />, {
      title: i18n.t('page.myProfile.receivingMailbox.createDialog.title'),
    });

  return (
    <MyProfileTemplate
      header={{
        title: i18n.t('page.myProfile.labels.emailSynchronization'),
        actions: [
          {
            type: 'button',
            title: i18n.t('general.labels.createNew'),
            onClick: handleCreate,
          },
        ],
        breadcrumbs: [
          {label: i18n.t('entity.user.labels.myProfile'), isCurrentPage: true},
          {
            label: i18n.t('page.myProfile.labels.emailSynchronization'),
            isCurrentPage: true,
          },
        ],
      }}
      data-testid="integrations-emailSynchronization-settings"
    >
      <VStack spacing={6}>
        <Grid columns={2} spacing={6}>
          <ReceivingMailboxesSection />
        </Grid>
        <VStack spacing={4}>
          <Heading size={4}>{i18n.t('page.myProfile.receivedMessages.sectionTitle')}</Heading>
          <SyncedMessagesDatagrid />
        </VStack>
      </VStack>
    </MyProfileTemplate>
  );
}
